<template>
  <div class="partialLoading" v-if="isShow">
    <div class="loader"><img src="./../assets/loading.gif"></div>
  </div>
</template>

<script>
  export default {
    name: 'PartialLoading',
    props: ['_isShow'],
    data: function() {
      return {};
    },
    computed: {
      isShow() {
        return this._isShow || false;
      }
    }
  };
</script>

<style scoped lang="scss">
  .partialLoading {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 14px;
    width: 100%;
    height: 100%;
    background-color: #fff;
    opacity: .9;
    z-index: 1000;

    .loader {
      position: absolute;
      left: 50%;
      top: 40%;
      margin-left: -7em;

      img {
        width: 14em;
        display: block;
      }
    }
  }
</style>